<template>
    <v-card>

        <v-card-text class="d-flex flex-column">

            <v-form style="gap: 16px;" class="d-flex flex-row flex-sm-column flex-lg-row flex-x l-row" ref="form"
                @submit.prevent>

                <div style="display: flex; flex-direction: column; width:100%;">

                    <div style="padding: 0;">
                        <v-col no-gutters>
                            <div class="upper-text body-2 mb-4 font-weight-medium">Personal information</div>

                            <v-col class="d-flex flex-column" style="gap: 24px; padding: 0;" no-gutters>

                                <v-col style="padding: 0;" no-gutters>
                                    <v-row no-gutters style="gap: 6px; flex-wrap: nowrap;"
                                        v-if="localizable_fields !== undefined && localizable_fields.length > 0">

                                        <v-col cols="12" sm="6" style="padding: 0;"
                                            v-for="(field, index) in localizable_fields" :key="index + 'locfield'">
                                            <!-- Hack for current localization to auto refresh, set showField to false, then true -->
                                            <v-text-field prepend-icon="mdi-account-outline"
                                                v-if="field.type === 'textfield' && showField === true"
                                                v-model="CurrentLocalization[field.value]" :placeholder="field.text"
                                                :label="field.text" @change="localizedTextfieldChanged(field.value)"
                                                @input="localizedTextfieldChanged(field.value)" outlined>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <!-- <v-row class="mb-4" no-gutters
                                        style="gap: 6px; flex-wrap: nowrap;">
                                        <v-col cols="12" sm="6" style="padding: 0;">
                                            <v-text-field label="First Name" prepend-icon="mdi-account-outline"
                                                :value="CurrentLocalization['firstName']" hide-details
                                                outlined></v-text-field> </v-col>
                                        <v-col cols="12" sm="6" style="padding: 0;">
                                            <v-text-field label="Last Name" :value="CurrentLocalization['lastName']"
                                                hide-details prepend-icon="mdi-account-outline" outlined></v-text-field>
                                        </v-col>
                                    </v-row> -->

                                    <v-row no-gutters style="gap: 6px; flex-wrap: nowrap;">
                                        <v-col cols="12" sm="6" style="padding: 0;">
                                            <v-menu v-model="fromDateMenu" :close-on-content-click="false"
                                                transition="scale-transition" offset-y min-width="auto">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field outlined :value="ActualCurrentEntity['dateOfBirth']"
                                                        label="Date of Birth" prepend-icon="mdi-calendar"
                                                        v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="ActualCurrentEntity['dateOfBirth']" no-title
                                                    scrollable>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <div class="div-textfield" style="width: 100%; margin-left: 30px;">
                                            <label class="qr-label" color="red">Gender</label>
                                            <v-row no-gutters style="padding: 0;">
                                                <v-radio-group v-model="ActualCurrentEntity['idGender']" row>
                                                    <v-radio label="Male" :value=1></v-radio>
                                                    <v-radio label="Female" :value=2></v-radio>
                                                </v-radio-group> </v-row>
                                        </div>
                                    </v-row>

                                    <v-col cols="12" sm="6" style="padding: 0;">
                                        <v-select v-model="ActualCurrentEntity['idBloodType']" :items="bloodTypes" attach
                                            chips prepend-icon="mdi-water-outline" outlined label="Blood Type"></v-select>
                                    </v-col>

                                </v-col>

                                <div class="d-flex flex-column">
                                    <v-col style="padding: 0;" class="d-flex flex-column mb-4" no-gutters>
                                        <div class="upper-text body-2 mb-1 font-weight-medium">Contact information</div>
                                    </v-col>

                                    <v-col style="padding: 0;" no-gutters><v-row class="mb-4" no-gutters
                                            style="gap: 6px; flex-wrap: nowrap;">
                                            <v-col cols="12" sm="6" style="padding: 0;">
                                                <v-text-field label="Email" prepend-icon="mdi-email-outline"
                                                    v-model="ActualCurrentEntity['email']"
                                                    :value="current_entity[entityName]['email']" hide-details
                                                    outlined></v-text-field> </v-col>
                                            <v-col cols="12" sm="6" style="padding: 0;">
                                                <v-text-field label="Main Phone Number"
                                                    v-model="ActualCurrentEntity['mainPhoneNumber']"
                                                    :value="current_entity[entityName]['mainPhoneNumber']" hide-details
                                                    prepend-icon="mdi-phone-outline" outlined></v-text-field> </v-col>
                                        </v-row>
                                        <!-- <v-checkbox v-model="checkbox" label="Send to Freight Forwarder"></v-checkbox> -->
                                    </v-col>
                                </div>

                                <div class="d-flex flex-column">
                                    <v-col style="padding: 0;" class="d-flex flex-column mb-4" no-gutters>
                                        <div class="upper-text body-2 mb-1 font-weight-medium">Security / Rating</div>
                                    </v-col>

                                    <v-col style="padding: 0;" no-gutters><v-row class="mb-4" no-gutters
                                            style="gap: 6px; flex-wrap: nowrap;">
                                            <v-col cols="12" sm="6" style="padding: 0;">
                                                <v-text-field label="Password" prepend-icon="mdi-lock-outline"
                                                    v-if="password_shown" v-model="ActualCurrentEntity['password']"
                                                    :value="current_entity[entityName]['password']" hide-details
                                                    outlined></v-text-field>
                                                <v-btn color="primary" class="mt-4" @click="generateUPassword()"
                                                    style="font-size:12px">Generate new Password</v-btn>
                                            </v-col>
                                            <v-col cols="12" sm="6" style="padding: 0;">
                                                <v-text-field label="Rating (1-5)"
                                                    :value="current_entity[entityName]['rating']"
                                                    v-model="ActualCurrentEntity['rating']" hide-details
                                                    prepend-icon="mdi-star-outline" outlined></v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-row no-gutters>
                                            <v-col style="padding: 0;" cols="12" sm="6">
                                                <v-checkbox v-model="ActualCurrentEntity.sendToFreight"
                                                    label="Send to Freight Forwarder" color="primary"
                                                    :value="ActualCurrentEntity.sendToFreight" hide-details
                                                    @change="ActualCurrentEntity.freightForwarderUrl = field.url"></v-checkbox>
                                            </v-col>

                                            <v-col style="padding: 0;" cols="12" sm="6">

                                                <v-text-field v-if="ActualCurrentEntity.sendToFreight"
                                                    v-model="ActualCurrentEntity.freightForwarderEmail"
                                                    placeholder="Freight Forwarder Email" label="Freight Forwarder Email"
                                                    outlined hide-details></v-text-field>
                                            </v-col>
                                        </v-row>

                                    </v-col>
                                </div>

                            </v-col>
                        </v-col>
                    </div>

                </div>

                <div class="custom-divider"></div>

                <div style="display: flex; flex-direction: column; width:100%; gap: 16px;">

                    <div style="gap: 16px; display: flex; flex-direction: column;" no-gutters>

                        <v-col class="d-flex flex-column" style="justify-content: space-between; gap: 24px; padding: 0 12px"
                            no-gutters>

                            <div style="gap: 4px;">
                                <div class="upper-text body-2">Media Details</div>
                                <div class="lower-text-gray body-1">Update images here</div>
                            </div>

                            <v-row class="justify-space-between mt-" no-gutters>

                                <div class="div-media">
                                    <label class="qr-label" color="red">Profile Image</label>
                                    <v-col style="padding: 0; display: flex; flex-direction: column; gap: 4px;">
                                        <div v-if="shouldShowMedia(1)"
                                            :style="`height: 100px; background-position: center; object-fit: cover;background-size:contain;background-image:url(${getMediaUrl(1)});`">

                                        </div>

                                        <v-btn icon dark style="align-self: flex-end; display: flex;"><v-icon
                                                color="primary"
                                                @click="openMediaGallery(1)">mdi-pencil-outline</v-icon></v-btn>
                                    </v-col>

                                </div>
                                <MediaGallery v-model="modal.mediaGalleryShown[`type${1}`]" @select="selectMedia"
                                    @mediaDeleted="removeMedia" :type="1" :userId="0"
                                    :driverId="current_entity['driver'].id"
                                    :truckId="current_entity['truck'].id !== undefined ? 0 : 0"></MediaGallery>

                                <div class="div-media">
                                    <label class="qr-label" color="red">Driver’s License</label>
                                    <v-col style="padding: 0; display: flex; flex-direction: column; gap: 4px;">
                                        <div v-if="shouldShowMedia(6)"
                                            :style="` height: 100px; background-position: center; object-fit: cover;background-size:contain;background-image:url(${getMediaUrl(6)});`">
                                        </div>

                                        <v-btn icon dark style="align-self: flex-end; display: flex;"><v-icon
                                                color="primary"
                                                @click="openMediaGallery(6)">mdi-pencil-outline</v-icon></v-btn>
                                    </v-col>

                                </div>
                                <MediaGallery v-model="modal.mediaGalleryShown[`type${6}`]" @select="selectMedia"
                                    @mediaDeleted="removeMedia" :type="6" :userId="0"
                                    :driverId="current_entity['driver'].id"
                                    :truckId="current_entity['truck'].id !== undefined ? 0 : 0"></MediaGallery>

                                <div class="div-media">
                                    <label class="qr-label" color="red">Truck Registration Card</label>
                                    <v-col :style="`padding: 0; display: flex; flex-direction: column; gap: 4px;`">
                                        <div v-if="shouldShowMedia(7)"
                                            :style="`height: 100px; background-position: center; object-fit: cover;background-size:contain;background-image:url(${getMediaUrl(7)});`"
                                            contain>

                                        </div>

                                        <v-btn icon dark style="align-self: flex-end; display: flex;"><v-icon
                                                color="primary"
                                                @click="openMediaGallery(7)">mdi-pencil-outline</v-icon></v-btn>
                                    </v-col>

                                </div>
                                <MediaGallery v-model="modal.mediaGalleryShown[`type${7}`]" @select="selectMedia"
                                    @mediaDeleted="removeMedia" :type="7" :userId="0"
                                    :driverId="current_entity['driver'].id"
                                    :truckId="current_entity['truck'].id !== undefined ? 0 : 0"></MediaGallery>

                            </v-row>


                        </v-col>

                    </div>


                </div>


            </v-form>

        </v-card-text>
        <v-btn color="red" text @click="closeClicked">Close</v-btn>
        <v-btn color="green" text @click="save" :loading="postLoading">Save</v-btn>
    </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import GoogleMap from '../GoogleMap'
import MobilePhones from '../../views/MobilePhones'
import MobilePhonesStandalone from '../MobilePhonesStandalone'
import Multiselect from 'vue-multiselect'
import MediaGallery from '../common/MediaGallery'
import Utils from '../../mixins/utils'
import ShareByEmail from '../../mixins/shareByEmail'
export default {
    data() {
        return {
            errorMessage: '',
            bloodTypes: [
                { text: "A+", value: 1 }, { text: "A-", value: 2 }, { text: "B+", value: 3 }, { text: "B-", value: 4 },
                { text: "AB+", value: 5 }, { text: "AB-", value: 6 }, { text: "O+", value: 7 }, { text: "O-", value: 8 },
            ],
            enableValidation: false,
            showDeleteConfirm: false,
            rules: {
                field: [
                    v => !!v || 'This Field is Required',
                ]
            },
            lang_code: 'en',
            showField: true, //hack to reload the localizable field,
            showAddStandalonePhone: false,
            standalone_phones: [],
            fromDateMenu: false,
            minDate: "1900-01-01",
            search_val: null,

            selectedMulti: [],
            modal: {
                mediaGalleryShown: {
                    type1: false,
                    type2: false,
                    type3: false,
                    type4: false,
                    type5: false,
                    type6: false,
                    type7: false,
                    type8: false
                },
                qrCodeGalleryShown: false
            },
            showQr: true,
            postLoading: false,
            email_shown: true,
            password_shown: true,
        }
    },
    mixins: [Utils, ShareByEmail],
    components: { GoogleMap, MobilePhones, MobilePhonesStandalone, Multiselect, MediaGallery },
    computed: {
        show: {
            get() {
                return this.isShown
            },
            set(value) {
                this.standalone_phones = []
                this.$emit('changed', value)
            }
        },
        driver() {
            return this.current_entity['driver']
        },
        headers() {
            return [
                {
                    text: 'Email',
                    value: 'email',
                    type: 'textfield',
                    autogenerated: true,
                    localizedGenerateField: "firstName"
                },
                {
                    text: 'Main Phone Number',
                    value: 'mainPhoneNumber',
                    type: 'textfield',
                },
                {
                    text: 'Profile Image',
                    value: 'profileImage',
                    type: 'media_gallery',
                    media_type: 1,
                    userId: 0,
                },
                {
                    text: 'Driver\'s License',
                    value: 'id',
                    type: 'media_gallery',
                    media_type: 6,
                    userId: 0,
                    hide_in_table: true
                },
                {
                    text: 'Truck Registration Card',
                    value: 'id',
                    type: 'media_gallery',
                    media_type: 7,
                    userId: 0,
                    hide_in_table: true
                },
                {
                    text: 'Insurance Policy',
                    value: 'id',
                    type: 'media_gallery',
                    media_type: 8,
                    userId: 0,
                    hide_in_table: true
                },
                {
                    text: 'Gender',
                    value: 'idGender',
                    type: 'radio',
                    options: this.genders
                },
                {
                    text: "Date Of Birth",
                    value: "dateOfBirth",
                    type: 'date',
                    hide_in_table: true
                },
                {
                    text: "Date Of Birth",
                    value: "strDateOfBirth",
                    type: 'textfield',
                    not_editable: true
                },
                {
                    text: 'Blood Type',
                    value: 'idBloodType',
                    type: 'select',
                    options: this.blood_types
                },
                {
                    text: 'Rating(1-5)',
                    value: 'rating',
                    type: 'textfield'
                },
                {
                    text: 'Password',
                    value: 'password',
                    type: 'textfield',
                    hide_in_table: true,
                    autogenerated: '123456'
                },
                // {
                //   text:"Email Verified",
                //   value: "emailVerified",
                //   type:'checkbox'
                // },
                {
                    text: "Send to freight forwarder",
                    type: "freight",
                    url: "driver/shareByEmail"
                }
                // {
                //   text: "Mobile Phones",
                //   value: "phones",
                //   type:'mobile_phone',
                // }
            ]
        },

        localizable_fields() {
            return [
                {
                    text: 'First Name',
                    value: 'firstName',
                    type: 'textfield'
                },
                {
                    text: 'Last Name',
                    value: 'lastName',
                    type: 'textfield'
                }
            ]
        },
        isExistingEntity() {
            return this.current_entity[this.entityName] != undefined && this.current_entity[this.entityName].id
        },
        ...mapState('entities', ['loading', 'current_entity', 'entities', 'search', 'selected_search_entity']),
        ...mapState('users', ['user']),
        ...mapGetters('entities', ['allowDelete']),
        ActualCurrentEntity() {
            return this.current_entity[this.entityName]
        },
        Languages() {
            return this.entities['language']
        },
        CurrentLanguage() {
            for (var i = 0; i < this.Languages.length; ++i) {
                var lang = this.Languages[i]
                if (lang.code === this.lang_code) return lang
            }
            return null
        },
        CurrentLocalization() {
            if (this.ActualCurrentEntity.localizations === undefined || !Array.isArray(this.ActualCurrentEntity.localizations)) {
                this.ActualCurrentEntity.localizations = []
            }

            var loc = null;
            var loc_found = false
            for (var i = 0; i < this.ActualCurrentEntity.localizations.length; ++i) {
                var l = this.ActualCurrentEntity.localizations[i]
                if (l.languageId === this.CurrentLanguage.id) loc = l
            }
            if (loc === null) {
                loc = { languageId: this.CurrentLanguage.id }
                for (var i = 0; i < this.localizable_fields.length; ++i) {
                    loc[this.localizable_fields[i].value] = ""
                }
                this.current_entity[this.entityName].localizations.push(loc)
            }
            return loc
        },
        CurrentSearchEntity(name) {
            return this.current_entity[name] !== undefined ? this.entities[name].find(x => x.id === this.current_entity[name].userId) : this.selected_search_entity[name]
        },
        StationsSelects() {
            return this.entity_fields.filter(h => h.type === 'multiselect' && h.include_in_station);
        }
    },
    props: ['fullscreen', 'isShown', 'entityName', 'coordinate', 'entity_fields', 'localizable_fields', 'user_id', 'driver_id'], //the data we're editing might belong to a user or driver
    methods: {
        ...mapActions('entities', ['getEntities', 'saveEntity', 'deleteEntity', 'searchEntities']),

        save() {
            if (this.$refs.form.validate()) {
                this.postLoading = true
                this.errorMessage = ''
                var post_object = { ...this.ActualCurrentEntity }

                post_object.entity_name = this.entityName
                if (this.standalone_phones.length > 0) post_object.phones = this.standalone_phones
                if (this.selected_search_entity['user'] !== undefined) {
                    post_object.userId = this.selected_search_entity['user'].id
                }
                if (post_object.packages !== undefined) {
                    post_object.packageIds = post_object.packages.map(p => p.id)
                    post_object.packages = null;
                    post_object.packageWayBills = null
                }
                if (post_object.drivers !== undefined) {
                    post_object.driverIds = post_object.drivers.map(d => d.id)
                    post_object.drivers = null
                    post_object.driverWayBills = null
                }
                if (post_object.trucks !== undefined) {
                    post_object.truckIds = post_object.trucks.map(t => t.id)
                    post_object.trucks = null
                    post_object.truckWayBills = null
                }
                if (post_object.user !== undefined) {
                    post_object.userId = post_object.user.id
                    post_object.user = null
                }
                if (post_object.qrCodeMedia !== undefined) {
                    if (post_object.qrCodeMedia.id !== undefined) {
                        post_object.qrCodeMediaId = post_object.qrCodeMedia.id
                        post_object.qrCodeMedia = null
                    }
                }
                if (this.user_id !== undefined) post_object.userId = this.user_id
                if (this.selected_search_entity['driver'] !== undefined) post_object.driverId = this.selected_search_entity['driver'].id
                if (this.driver_id !== undefined) post_object.driverId = this.driverId

                post_object.isActive = true;
                console.log(post_object)
                this.saveEntity(post_object).then(message => {
                    console.log(`post success`);
                    this.$emit('entityPosted');
                    this.postLoading = false;
                    if (post_object.sendToFreight !== undefined && post_object.sendToFreight === true) {
                        console.log('should send to freight');
                        this.sendToFreight(false, post_object);
                    }
                    this.getEntities(this.entityName);//this.selectedFFId)
                    this.driverDetailsShown = false;
                    this.closeClicked();
                }).catch(message => {
                    if (message == null) {
                        this.errorMessage = "There are validation errors. Kindly check your inputs and try again.";
                    } else {
                        this.errorMessage = message;
                    }
                    this.postLoading = false;
                })
            }
            this.enableValidation = true;
        },
        deleteEntity() {
            this.showDeleteConfirm = false
            this.deleteEntity(this.current_entity[this.entityName], this.entityName).then(message => {
                this.show = false;
            }).catch(message => {
                this.errorMessage = message;
            })
        },
        setLanguage(lang) {
            this.showField = false;
            this.lang_code = lang.code;
            setTimeout(h => { this.showField = true }, 100);
        },
        clearSearch(entity) {
            this.search[entity] = [];
        },
        getSearchItems() {
            var items = this.search['user'];
            return items;
        },
        fetchEntriesDebounced() {
            clearTimeout(this._searchTimerId);
            this._searchTimerId = setTimeout(() => {
                this.fetchEntries();
            }, 500) /* 500ms throttle */
        },
        onSelect(option, id) {
            console.log(option, id);
        },
        addTag(newTag) {
            const tag = {
                name: newTag,
                code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
            }
            this.options.push(tag);
            this.value.push(tag);
        },
        selectMedia(item) {
            if (item.typeId === 5) {
                this.ActualCurrentEntity.qrCodeMediaId = item.id;
                this.ActualCurrentEntity.qrCodeMedia = item;
                this.ActualCurrentEntity.qrCode = item.name;
            }
            else {
                if (!(this.current_entity[this.entityName] != undefined && this.current_entity[this.entityName].id)) {
                    item.id = null;
                }
                if (this.ActualCurrentEntity.medias == null) this.ActualCurrentEntity.medias = []
                //find first an item with the same type and replace it
                var mediaIndex = this.ActualCurrentEntity.medias.findIndex(m => m.typeId == item.typeId)
                if (mediaIndex === undefined || mediaIndex === -1) {
                    this.ActualCurrentEntity.medias.push(item);
                }
                else {
                    this.ActualCurrentEntity.medias[mediaIndex] = item;
                }
            }
        },
        removeMedia(item) {
            var index = this.ActualCurrentEntity.medias.indexOf(m => m.id === item.id);
            if (index !== undefined && index !== null) {
                this.ActualCurrentEntity.medias.splice(index, 1);
            }
        },
        getMediaUrl(type) {
            if (this.ActualCurrentEntity.medias !== null && Array.isArray(this.ActualCurrentEntity.medias)) {
                var media = this.ActualCurrentEntity.medias.find(obj => obj.typeId === type)
                return (media !== undefined && media !== null) ? media.url : ""
            }
            return null;
        },
        shouldShowMedia(type) {
            if (this.ActualCurrentEntity.medias !== null && Array.isArray(this.ActualCurrentEntity.medias)) {
                var media = this.ActualCurrentEntity.medias.filter(obj => obj.typeId === type)
                return (media !== undefined && media !== null) ? true : false;
            }
        }
        ,
        openMediaGallery(media_type) {
            this.modal.mediaGalleryShown[`type${media_type}`] = true;
        },
        setGeoFence(fence) {
            this.ActualCurrentEntity.geoRegions = fence;
        },
        setStationsList(stationsList) {
            this.ActualCurrentEntity.deliveryAddresses = stationsList;
        },
        generateChipStyle(color) {
            var styleDef = `.${color} .multiselect__tag{background:${color} !important;}`
            let style = document.createElement('style');
            style.type = 'text/css';
            style.innerHTML = styleDef;
            document.head.appendChild(style);
            return color;
        },
        generateQrCode(id, selectorValue, selectorId) {
            axios({
                method: "GET",
                url: `${process.env.VUE_APP_baseURL}media/generateQr?id=${id}`
            }).then(response => {
                var qrMedia = response.data.data.value;
                this.ActualCurrentEntity[selectorValue] = qrMedia;
                this.ActualCurrentEntity[selectorId] = qrMedia.id;
                this.ActualCurrentEntity.qrCode = qrMedia.name;
                this.forceReloadQr();
            }).catch(error => {
                console.log(`ERRORRRRRRRRR ${error}`);
            })
        },
        forceReloadQr() {
            this.showQr = false
            setTimeout(() => { this.showQr = true }, 150);
        },
        closeClicked() {
            this.$emit('closeClicked');
        },
        localizedTextfieldChanged(fieldName) {
            console.log(`${fieldName} changed`);
            if (fieldName != null && fieldName.includes('firstName') && this.CurrentLocalization.languageId === 1) {
                var value = this.CurrentLocalization[fieldName];
                var filteredValue = value.replace(" ", "_");
                this.ActualCurrentEntity.email = `${filteredValue}@tracking.com`;
                this.email_shown = false;
                setTimeout(() => {
                    this.email_shown = true
                }, 50);
            }
        },
        generateUPassword() {
            this.ActualCurrentEntity.password = Array(10).fill("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz").map(function (x) { return x[Math.floor(Math.random() * x.length)] }).join('');
            this.password_shown = false;
            setTimeout(() => { this.password_shown = true }, 50);
        },
        sendToFreight(genNewPassword = true, post_object = null) {
            console.log('sending to')
            if (genNewPassword || this.ActualCurrentEntity.password === undefined || this.ActualCurrentEntity.password.length === 0) this.generateUPassword()
            var emailObject = {
                entityId: post_object.id,
                email: post_object.email,
                password: post_object.password
            }
            var url = `${this.entityName}/shareByEmail`;
            this.sendEmailEntity(emailObject, url);
        }
    },
    model: {
        prop: 'isShown',
        event: 'changed'
    },
    watch: {
        show(newValue) {
            if (newValue) {
                this.data = Object.assign({}, this.user)
                if (this.$refs.form != undefined)
                    this.$refs.form.resetValidation();

                this.errorMessage = '';
                this.enableValidation = false;
            }
            else {
                this.ActualCurrentEntity = {}
                this.$emit('editItemHidden');
            }
        },
        data: {
            deep: true,
            handler() {
                if (this.enableValidation)
                    this.$refs.form.validate();
            }
        },
        search_val(val) {
            if (this.search['user'] !== undefined && this.search['user'].length > 0) return
            if (val !== undefined && val !== null) {
                //search for the user and populate the users
                var searchPayLoad = {
                    entity_name: 'user',
                    query: val,
                    fromPage: -1,
                    toPage: -1,
                    count: -1
                }
                this.searchEntities(searchPayLoad)
            }
        }
    },
    mounted() {
        this.errorMessage = "";
        if (this.localizable_fields !== undefined && this.localizable_fields.length > 0) {
            //should check if the current entity has a localizations array, else add one
            if (this.ActualCurrentEntity.localizations === undefined || !Array.isArray(this.ActualCurrentEntity.localizations)) {
                this.ActualCurrentEntity.localizations = [];

                //load the array with empty localiable fields for each language
                for (var i = 0; i < this.Languages.length; ++i) {
                    var loc = {};
                    loc.languageId = this.Languages[i].id;
                    for (var j = 0; j < this.localizable_fields.length; ++j) {
                        var field = this.localizable_fields[j];
                        loc[field.value] = "";
                    }
                    this.ActualCurrentEntity.localizations.push(loc);
                }
            }
        }
        if (this.ActualCurrentEntity.id === undefined || this.ActualCurrentEntity.id === 0) {
            this.ActualCurrentEntity.password = "123456";
        }
        this.localizedTextfieldChanged("firstName");
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.img-div {
    background-size: contain;
    margin-bottom: 15px;
    height: 100px;
}

.logo-container {
    text-align: center;
}

@media print {
    header {
        display: none;
    }
}
</style>